var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"construct-visual-group",class:_vm.item.class,style:(_vm.groupStyle)},[_c('Renderer',{attrs:{"content":_vm.item.content || [],"line":_vm.line,"page":_vm.page,"itemData":_vm.itemData,"actionResolver":_vm.actionResolver},on:{"action":function($event){return _vm.$emit('action', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }